import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { CircularProgress } from '@material-ui/core'
import SocketEventHandler from '../Common/SocketEventHandler'

import { registerSocketMessage, getInbox, getIntentEntityMap } from './actions'

import DisconnectSnackbar from './DisconnectSnackbar'

import Header from './Header'
import Sidebar from './Sidebar'

import Dialogue from './Dialogue'
import Details from './Details'

import './index.scss'

class OperatorDashboard extends React.PureComponent {
    constructor(props) {
        // constructor
        super(props)

        this.state = {
            dialogueHandlers: {},
            isConnected: false,
        }

        this.dispatchSelectedDialogue = this.dispatchSelectedDialogue.bind(this)
        document.title = 'Monitor Dashboard'
    }

    componentDidMount() {
        this.connectToSocket()
        this.props.getIntentEntityMap()
    }

    connectToSocket() {
        const operatorToken = localStorage.getItem(
            'pulsarBotPlatform_operatorToken'
        )

        const socketOptions = {
            forceNew: true,
            transportOptions: {
                polling: {
                    extraHeaders: {
                        'Platform-Token': operatorToken,
                    },
                },
            },
        }

        const eventHandler = new SocketEventHandler(
            socketOptions,
            (event, data) => {
                this.handleSocketEvent(event, data)
            }
        )

        this.setState({ eventHandler })
    }

    handleSocketEvent(event, data) {
        switch (event) {
            case 'message-receive':
                // cloudwatch OPDASH client SocketEventHandler in /Dashboard component, {data, time}

                this.registerNewMessage(data)
                return
            case 'user-info':
                this.setState({ user: data })
                return
            case 'dialogue-handler':
                this.setState({ dialogueHandlers: data })
                return
            case 'disconnect':
                this.setState({ isConnected: false })
                return
            case 'reconnect':
                this.setState(
                    { isConnected: true }
                    // Vakhtang: Commented this, because in Sidebar component the api is being called
                    // anyways so there is no need for two callings
                    // () => {
                    //     this.props.getInbox({ start: this.props.start, end: this.props.end, type: 'inbox' })
                    // }
                    // eslint-disable-next-line function-paren-newline
                )
                break
            default:
                break
        }
    }

    registerNewMessage(data) {
        this.props.registerSocketMessage(data)
    }

    dispatchSelectedDialogue(dialogueKey) {
        const { eventHandler } = this.state

        eventHandler.emitEvent('active-dialogue', { dialogueKey })
    }

    render() {
        const {
            user, loading, isConnected, dialogueHandlers
        } = this.state

        if (this.props.loadingIntentEntityMap) {
            return (
                <div className='init-loader-wrapper'>
                    <CircularProgress size={60} />
                </div>
            )
        }

        return (
            <div className='OperatorDashboard'>
                {!loading && (
                    <div>
                        <Header user={user} />

                        <div className='OperatorDashboard__content'>
                            <DisconnectSnackbar isConnected={isConnected} />

                            <Sidebar
                                dialogueHandlers={dialogueHandlers}
                                dispatchSelectedDialogue={
                                    this.dispatchSelectedDialogue
                                }
                            />

                            <Dialogue />

                            <Details editInProgress={false} />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { start, end } = state.operatorDashboardPeriods
    const { loadingIntentEntityMap, intentEntityMap } = state.operatorDashboard
    return {
        start,
        end,
        loadingIntentEntityMap,
        intentEntityMap,
    }
}

export default withRouter(
    connect(mapStateToProps, {
        registerSocketMessage,
        getInbox,
        getIntentEntityMap,
    })(OperatorDashboard)
)
